import {
  getHotelRoomDistribution,
  getAvailableTourOperatorsList,
  getAvailableContractsList,
  getTourOperationsReservationsList,
  getGroupsALG
} from '../../../commons/apiCalls';

const mapStateToProps = state => ({
  userDefaultHotel: state.session.userDefaultHotel,
  hotelCode: state.tourOperation.hotel,
  hotelsList: state.session.allHotelsList,
  operatorCode: state.tourOperation.operator,
  operatorsList: state.tourOperation.operatorsList,
  locatorTTOO: state.tourOperation.locatorTTOO
});

const mapDispatchToProps = dispatch => ({
  setHotelFilter: (hotelCode) => {
    dispatch({
      type: 'SET_SELECTED_HOTEL',
      hotelCode
    });
  },
  setOperatorFilter: (operatorCode) => {
    dispatch({
      type: 'SET_SELECTED_OPERATOR',
      operatorCode
    })
  },
  setLocatorFilter: (locatorCode) => {
    dispatch({
      type: 'SET_SELECTED_LOCATOR',
      locatorCode
    })
  },
  getTourOperatorsList: (hotelCode, errorCallBack, requestCallBack) => {
    dispatch(getAvailableTourOperatorsList(hotelCode, errorCallBack, requestCallBack));
  },
  getRoomsListByTourOperator: (hotelCode, tourOperator, errorCallBack, requestCallBack) => {
    dispatch(
      getHotelRoomDistribution(
        hotelCode,
        tourOperator,
        errorCallBack,
        requestCallBack
      )
    );
  },
  getContractsList: (hotelCode, tourOperator, errorCallBack, requestCallBack) => {
    dispatch(
      getAvailableContractsList(
        hotelCode,
        tourOperator,
        errorCallBack,
        requestCallBack
      )
    );
  },
  getReservationsList: (hotelCode, tourOperator, locatorTTOO, errorCallBack, requestCallBack) => {
    dispatch({ type: 'CLEAN_CONTRACT_DETAIL_LIST' });
    dispatch({ type: 'CLEAN_RESERVATIONS_LISTS' });
    dispatch(
      getTourOperationsReservationsList(
        hotelCode,
        tourOperator,
        locatorTTOO,
        errorCallBack,
        requestCallBack
      )
    );
  },
  getHotelGroups: (hotelCode, errorCallBack) => {
    dispatch(
      getGroupsALG(hotelCode, errorCallBack)
    );
  }
});

export { mapStateToProps, mapDispatchToProps };
